import { render, staticRenderFns } from "./leftMenu-index.vue?vue&type=template&id=162c983e&scoped=true"
import script from "./leftMenu-index.vue?vue&type=script&lang=js"
export * from "./leftMenu-index.vue?vue&type=script&lang=js"
import style0 from "./leftMenu-index.vue?vue&type=style&index=0&id=162c983e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162c983e",
  null
  
)

export default component.exports